/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { questionWithScoreDataAttributeSchema } from './QuestionWithScoreDataAttributeSchema'
import { questionWithScoreDataSubtypeSchema } from './QuestionWithScoreDataSubtypeSchema'
import { questionWithScoreDataTypeSchema } from './QuestionWithScoreDataTypeSchema'

export const questionWithScoreDataSchema = z.object({
	scoreWeight: z.number(),
	options: z.array(
		z.object({
			escoSkills: z.array(
				z.object({ conceptUri: z.string(), preferredLabel: z.string(), confirmedByUser: z.boolean() }),
			).nullable(),
			scoreValue: z.number().nullable(),
			isDisqualifying: z.boolean().nullable().default(false),
			id: z.string().uuid(),
			label: z.string(),
			position: z.number(),
			consentType: z.string().nullable(),
			escoMappingReason: z.string().nullable(),
		}),
	).nullable(),
	id: z.string().nullable(),
	label: z.string(),
	type: questionWithScoreDataTypeSchema,
	attribute: questionWithScoreDataAttributeSchema.nullable(),
	subtype: questionWithScoreDataSubtypeSchema.nullable(),
	validationRules: z.array(z.string()).nullable(),
	position: z.number(),
	updatedAt: z.iso.datetime(),
})

export type QuestionWithScoreDataSchema = z.infer<typeof questionWithScoreDataSchema>
